import { render, staticRenderFns } from "./EnterVerificationCode.vue?vue&type=template&id=2b866b22&scoped=true"
import script from "./EnterVerificationCode.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnterVerificationCode.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EnterVerificationCode.vue?vue&type=style&index=0&id=2b866b22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b866b22",
  null
  
)

export default component.exports